export default __webpack_public_path__ + "static/media/unselected_checkbox.ac434ee4.svg";